import { Flex } from 'antd';
import { useTranslation } from 'translations/hooks';

import styles from './index.module.scss';

type Props = {
  totalRings: number | undefined;
  validatedRings: number | undefined;
  defectReports: number | undefined;
  segmentsUnderRepair: number | undefined;
};

export const RangeInfoCard = ({
  totalRings,
  validatedRings,
  defectReports,
  segmentsUnderRepair,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.card}>
      <Flex vertical gap={8}>
        <Flex vertical gap={4}>
          <span className={styles.subtitle}>
            {t(
              'qualityControl.recordSegmentDefect.rightPanel.rangeInfo.subtitle',
            )}
          </span>
          <strong className={styles.count}>
            {t(
              'qualityControl.recordSegmentDefect.rightPanel.rangeInfo.totalRings',
              { count: totalRings },
            )}
          </strong>
        </Flex>
        <Flex vertical gap={2}>
          <span className={styles.subtitle}>
            {t(
              'qualityControl.recordSegmentDefect.rightPanel.rangeInfo.listTitle',
            )}
          </span>
          <ul className={styles.infoList}>
            <li>
              {t(
                'qualityControl.recordSegmentDefect.rightPanel.rangeInfo.validatedRings',
                { count: validatedRings },
              )}
            </li>
            <li>
              {t(
                'qualityControl.recordSegmentDefect.rightPanel.rangeInfo.defectReports',
                { count: defectReports },
              )}
            </li>
            <li>
              {t(
                'qualityControl.recordSegmentDefect.rightPanel.rangeInfo.segmentsUnderRepair',
                { count: segmentsUnderRepair },
              )}
            </li>
          </ul>
        </Flex>
      </Flex>
    </div>
  );
};
